// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1dODu","savePackageButton":"ClientWallet_savePackageButton__3gtcS"};